import React, { useState, useEffect, useRef } from "react";
import { injectIntl, FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Button, Card, Badge, Row } from "@masterteam/mt-design-react";
import classNames from "classnames/bind";
import { getNotifications } from "../../reducers/notification";
import { addToast } from "../../helpers";
import api from "../../providers/api";
import { ReactComponent as NotificationsIcon } from "../../assets/images/notifications.svg";
import NotificationItem from "./NotificationItem";

import styles from "./Notifications.module.scss";

const cx = classNames.bind(styles);

function Notifications({ intl }) {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef();
  const history = useHistory();
  const dispatch = useDispatch();
  const [notifications, user] = useSelector(({ notification, user }) => [
    notification?.notifications,
    user,
  ]);
  const handleUpdateNotification = (id) => {
    api.notification
      .updateNotification(id)
      .then((res) => {
        if (res.StatusCode === "Success") {
          dispatch(getNotifications());
        }
      })
      .catch((error) => {
        addToast.error(error.message, {
          toastId: "get-users-error",
        });
      });
  };

  const handleOnClickNotification = ({ RelatedItemID, ID, ItemType }, type) => {
    handleUpdateNotification(ID);
    if (ItemType === "Initiative-CreateInitiative") {
      history.push(`/splus/add-new-initiative/${RelatedItemID}`);
    } else if (ItemType === "KPI-KPIChangeRequest") {
      history.push(`/splus/change-kpi-details/${RelatedItemID}`);
    } else if ((ItemType = "KPI-CreateKPI")) {
      history.push("/splus/task-center/approvals");
    } else history.push(type?.path || `/splus/kpi-details/${RelatedItemID}`);
  };

  const handleClickOutside = (event) => {
    if (wrapperRef?.current && !wrapperRef?.current?.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    dispatch(getNotifications());

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [user]);

  return (
    <div
      ref={wrapperRef}
      className={styles.notifications}
      onClick={() => {
        setIsOpen(!isOpen);
      }}
    >
      <div>
        <Button
          fill="none"
          variant="dark"
          Icon={NotificationsIcon}
          size="medium"
          shape="square"
          tooltip-position="buttom"
          tooltip={intl.formatMessage({
            id: "common.notifications",
            defaultMessage: "common.notifications",
          })}
        />
        {notifications.length > 0 && (
          <Badge
            shape="square"
            variant="secondary"
            size="small"
            className={styles.badge}
          >
            {notifications.length}
          </Badge>
        )}
      </div>
      <Card
        className={cx({
          notificationsList: true,
          displayBlock: isOpen,
        })}
      >
        <Row className={styles.notificationTitle}>
          <FormattedMessage id="common.notifications" />
        </Row>
        <div className={styles.notificationsBody}>
          {notifications.map((item) => (
            <NotificationItem
              key={item.ID}
              item={item}
              onClick={handleOnClickNotification}
            />
          ))}
        </div>
      </Card>
    </div>
  );
}

export default injectIntl(Notifications);
